export default {
      id: "arrow-push-usage",
      viewBox: "0 0 16 15",
      url: __webpack_public_path__ + "img/icons.svg#arrow-push",
      toString: function () {
        return this.url;
      }
    }